import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AmazonRdsForOracleLinkedService } from 'app/model/linkedservice/amazon-rds-for-oracle.linkedservice';
import { oracleAdapts, OracleLinkedServiceAdapter } from './oracle-linkedservice.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonRdsForOracleLinkedService),
    asynchronous: true,
    adapts: oracleAdapts
})
export class AmazonRdsForOracleAdapter extends OracleLinkedServiceAdapter {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => AmazonRdsForOracleLinkedService {
        return AmazonRdsForOracleLinkedService;
    }

    protected model(): IModel {
        return AmazonRdsForOracleLinkedService.MODEL;
    }

    protected override async propertiesToModelAsync(
        linkedServiceResource: Model.LinkedServiceResource,
        linkedService: AmazonRdsForOracleLinkedService
    ): Promise<AmazonRdsForOracleLinkedService> {
        return super.propertiesToModelAsync(linkedServiceResource, linkedService);
    }
}
